import mergeWith from 'lodash.mergewith';

// Default config for both self-assessment
const DEFAULT_CONFIG = {
  locale: 'en_US',
  colorMain: '#005B86',
  fontFamily: 'Poppins, sans-serif',
  fontInclude:
    'https://fonts.googleapis.com/css?family=Poppins:400,600&display=swap',
  autoScroll: false,
};

function customizer(objValue, srcValue, key) {
  if (!srcValue) return objValue;
  if (key === 'contactForm' || key === 'steps') return srcValue;
  return undefined;
}

function mergeConfigs(...configs) {
  return mergeWith({}, DEFAULT_CONFIG, ...configs, customizer);
}

export default mergeConfigs;
